import { useEffect } from 'react'
import { usePrefersReducedMotion } from './usePrefersReducedMotion'

const HOVER_SELECTOR = 'a, button, [data-magnetic], [data-cursor-hover]'

/**
 * Global cursor hook — mount ONCE inside SiteShell.
 * Drives .cursor-dot and .cursor-ring via rAF lerp.
 * No-op on touch devices and when prefers-reduced-motion is set.
 */
export function useCustomCursor() {
    const reducedMotion = usePrefersReducedMotion()

    useEffect(() => {
        const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches
        if (isTouch || reducedMotion) return

        const dot = document.querySelector('.cursor-dot')
        const ring = document.querySelector('.cursor-ring')
        if (!dot || !ring) return

        let mx = window.innerWidth / 2
        let my = window.innerHeight / 2
        let dx = mx, dy = my
        let rx = mx, ry = my
        let rafId

        const onMouseMove = (e) => { mx = e.clientX; my = e.clientY }
        const onMouseOver = (e) => {
            if (e.target.closest(HOVER_SELECTOR)) document.body.classList.add('cursor-hover')
        }
        const onMouseOut = (e) => {
            if (e.target.closest(HOVER_SELECTOR)) document.body.classList.remove('cursor-hover')
        }

        document.addEventListener('mousemove', onMouseMove)
        document.addEventListener('mouseover', onMouseOver)
        document.addEventListener('mouseout', onMouseOut)

        function tick() {
            dx += (mx - dx) * 0.6
            dy += (my - dy) * 0.6
            rx += (mx - rx) * 0.18
            ry += (my - ry) * 0.18
            dot.style.transform = `translate3d(${dx}px, ${dy}px, 0) translate(-50%, -50%)`
            ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`
            rafId = requestAnimationFrame(tick)
        }
        rafId = requestAnimationFrame(tick)

        return () => {
            document.removeEventListener('mousemove', onMouseMove)
            document.removeEventListener('mouseover', onMouseOver)
            document.removeEventListener('mouseout', onMouseOut)
            cancelAnimationFrame(rafId)
            document.body.classList.remove('cursor-hover')
        }
    }, [reducedMotion])
}
